exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".OpenTicketAddressCard-map-3CPe2{margin:-10px -44px 10px -10px}.OpenTicketAddressCard-step-2h2M9{display:inline-block;min-width:24px;padding:6px 0 4px;border-radius:12px;background:#dadada;font-size:14px;font-weight:400;color:#fff}.OpenTicketAddressCard-patrimony-2zj5K h4 small{margin-bottom:5px;text-transform:uppercase;font-size:14px;font-style:italic;color:inherit}.OpenTicketAddressCard-patrimony-2zj5K small{display:block;font-size:14px;font-weight:300;font-style:italic}.OpenTicketAddressCard-split-AXj5V .OpenTicketAddressCard-main-1qfx7{margin-top:36px}", ""]);

// exports
exports.locals = {
	"map": "OpenTicketAddressCard-map-3CPe2",
	"step": "OpenTicketAddressCard-step-2h2M9",
	"patrimony": "OpenTicketAddressCard-patrimony-2zj5K",
	"split": "OpenTicketAddressCard-split-AXj5V",
	"main": "OpenTicketAddressCard-main-1qfx7"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/OpenTicketAddressCard.less
// module id = 1762
// module chunks = 0